import { Divider, Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { formValidatorRules } from '../../../../../common/utils';
import ModalComponent from '../../../../../components/ModalComponent';

const { Item } = Form;
const { required } = formValidatorRules;

const ConfigRankingDescModal = ({
  isModalOpen,
  setIsModalOpen,
  item,
  form,
  onFinish,
  loadings,
  onClose,
}) => {
  const [isValidateTrigger, setIsValidateTrigger] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
    form?.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isModalOpen) return;
    if (item?.id) {
      form?.setFieldsValue({ description: item?.description });
    } else {
      form?.resetFields();
    }
  }, [form, isModalOpen, item]);

  return (
    <ModalComponent
      open={isModalOpen}
      onCancel={handleCancel}
      onOk={form?.submit}
      title="Edit Description"
      okText="Save"
      confirmLoading={loadings}
      destroyOnClose
      forceRender
      maskClosable={false}
    >
      <Divider />
      <Form
        form={form}
        onFinish={(values) => {
          onFinish(values);
          setIsValidateTrigger(true);
        }}
        autoComplete="off"
        layout="vertical"
        validateTrigger={isValidateTrigger ? 'onChange' : 'onSubmit'}
        onFinishFailed={() => setIsValidateTrigger(true)}
      >
        <Item
          label="Description"
          name="description"
          rules={[{ ...required, message: 'Please enter a description!' }]}
        >
          <Input.TextArea
            rows={4}
            allowClear
            placeholder="Enter Description"
            maxLength={800}
          />
        </Item>
      </Form>
    </ModalComponent>
  );
};

export default ConfigRankingDescModal;
